<template>

  <div>
    <parte1/>
    <parte2/>  
    <parte3/>  

  </div>

</template>

<script>
import parte1 from '../components/home/parte1'
import parte2 from '../components/home/parte2'
import parte3 from '../components/home/parte3'
export default {
  components:{
    parte1, parte2, parte3
  }
};
</script>
